export default {
  login: {
    title: 'เข้าสู่ระบบ FlowRent',
    welcome: 'ยินดีต้อนรับ',
    subtitle: 'กรอกข้อมูลเพื่อเข้าสู่บัญชีของคุณ',
    email: 'อีเมล',
    email_placeholder: 'you@example.com',
    password: 'รหัสผ่าน',
    password_placeholder: 'กรอกรหัสผ่าน',
    toggle_password_visibility: 'แสดงหรือซ่อนรหัสผ่าน',
    submit: 'เข้าสู่ระบบ',
    forgot_password: 'ลืมรหัสผ่าน?',
    privacy_policy: 'นโยบายความเป็นส่วนตัว',
    signup_link: 'สมัครใช้งาน',
    deletion_notice: {
      account: 'บัญชีนี้จะถูกลบถาวรหลังวันที่ {{date}} เข้าสู่ระบบภายในวันนั้นเพื่อกู้คืน',
      user: 'บัญชีเข้าใช้งานของคุณจะถูกลบถาวรหลังวันที่ {{date}} เข้าสู่ระบบภายในวันนั้นเพื่อกู้คืน',
    },
    pending_deletion: {
      account_message: 'บัญชีนี้ถูกลบแล้ว และจะถูกลบถาวรหลังวันที่ {{date}}',
      user_message: 'บัญชีเข้าใช้งานของคุณถูกลบแล้ว และจะถูกลบถาวรหลังวันที่ {{date}}',
      restore_button: 'กู้คืนบัญชี',
      owner_only: 'มีเพียงเจ้าของบัญชีเท่านั้นที่กู้คืนบัญชีนี้ได้',
    },
    brand: {
      headline: 'จัดการหอพักได้ง่ายขึ้น ในที่เดียว',
      subline: 'ครบตั้งแต่สัญญา บิล ค่าเช่า ติดตามการชำระเงิน และเชื่อมต่อผู้เช่าผ่าน LINE',
      features: {
        billing: 'ออกบิลและรับชำระเงินออนไลน์',
        lease: 'สร้างสัญญาเช่าดิจิทัล',
        reports: 'รายงานรายรับ-รายจ่ายครบ',
      },
      stats: {
        revenue_label: 'รายรับ (เดือนนี้)',
        units_label: 'ยูนิต',
        occupancy_label: 'เต็ม',
      },
    },
  },

  signup: {
    title: 'สมัครใช้งาน FlowRent',
    subtitle: 'กรอกข้อมูลเพื่อเปิดบัญชีใหม่',
    account_name: 'ชื่อกิจการหรือหอพัก',
    owner_first_name: 'ชื่อ',
    owner_last_name: 'นามสกุล',
    email: 'อีเมล',
    email_placeholder: 'you@example.com',
    phone: 'เบอร์โทรศัพท์',
    phone_placeholder: '0812345678',
    address: 'ที่อยู่',
    invitation_code: 'รหัสเชิญ',
    invitation_code_hint: 'รหัส 6 ตัวจากทีมงาน FlowRent',
    no_code: 'ไม่มีรหัสเชิญ? ติดต่อเรา',
    // EP-160 T160-201w (S9, D4): the onboarding grant, ticked by default.
    support_onboarding: {
      label: 'ให้ทีม FlowRent ช่วยตั้งค่าบัญชีได้ใน 30 วันแรก',
      detail: '(เห็นอาคาร ห้อง และราคา; เห็นข้อมูลผู้เช่าแบบปิดบังบางส่วน; ยกเลิกได้ทุกเมื่อ)',
    },

    // EP-160 (section 2.7, AC-10): the required terms box.
    terms: {
      accept: 'ฉันยอมรับข้อตกลงการใช้บริการและนโยบายความเป็นส่วนตัวของ FlowRent',
      terms_link: 'ข้อตกลงการใช้บริการ',
      privacy_link: 'นโยบายความเป็นส่วนตัว',
    },
    submit: 'สมัครใช้งาน',
    have_account: 'มีบัญชีอยู่แล้ว? เข้าสู่ระบบ',
    success: {
      title: 'ตรวจสอบอีเมลของคุณ',
      body: 'เราส่งลิงก์ตั้งรหัสผ่านไปที่ {{email}} แล้ว',
      expiry: 'ลิงก์ใช้ได้ {{hours}} ชั่วโมง',
      retry: 'หากลิงก์หมดอายุ ให้ใช้ "ลืมรหัสผ่าน" ด้วยอีเมลเดิม',
      sign_in: 'ไปหน้าเข้าสู่ระบบ',
    },
    errors: {
      invitation_code_invalid: 'รหัสเชิญไม่ถูกต้องหรือถูกใช้งานแล้ว',
      email_taken: 'อีเมลนี้มีบัญชี FlowRent อยู่แล้ว กรุณาเข้าสู่ระบบ',
      validation_failed: 'กรุณาตรวจสอบข้อมูลที่กรอก',
      rate_limited: 'สมัครบ่อยเกินไป กรุณาลองใหม่ภายหลัง',
      generic: 'สมัครไม่สำเร็จ กรุณาลองใหม่',
    },
    validation: {
      account_name_required: 'กรุณากรอกชื่อกิจการหรือหอพัก',
      first_name_required: 'กรุณากรอกชื่อ',
      last_name_required: 'กรุณากรอกนามสกุล',
      email_invalid: 'กรุณากรอกอีเมลให้ถูกต้อง',
      phone_invalid: 'กรุณากรอกเบอร์โทรศัพท์ให้ถูกต้อง',
      address_required: 'กรุณากรอกที่อยู่',
      account_name_too_long: 'กรอกได้ไม่เกิน {{max}} ตัวอักษร',
      first_name_too_long: 'กรอกได้ไม่เกิน {{max}} ตัวอักษร',
      last_name_too_long: 'กรอกได้ไม่เกิน {{max}} ตัวอักษร',
      address_too_long: 'กรอกได้ไม่เกิน {{max}} ตัวอักษร',
      code_length: 'รหัสเชิญต้องมี 6 ตัวอักษร',
      terms_required: 'กรุณายอมรับข้อตกลงการใช้บริการและนโยบายความเป็นส่วนตัวก่อนสมัคร',
    },
  },

  forgot_password: {
    title: 'ลืมรหัสผ่าน',
    subtitle: 'กรอกอีเมลเพื่อรับลิงก์รีเซ็ตรหัสผ่าน',
    email: 'อีเมล',
    email_placeholder: 'you@example.com',
    submit: 'ส่งลิงก์รีเซ็ต',
    back_to_login: 'กลับไปหน้าเข้าสู่ระบบ',
    success_message: 'หากมีบัญชีที่ใช้อีเมลนี้ คุณจะได้รับลิงก์รีเซ็ตรหัสผ่าน',
  },

  reset_password: {
    title: 'รีเซ็ตรหัสผ่าน',
    subtitle: 'กรอกรหัสผ่านใหม่ของคุณ',
    password: 'รหัสผ่านใหม่',
    password_placeholder: 'กรอกรหัสผ่านใหม่',
    confirm_password: 'ยืนยันรหัสผ่าน',
    confirm_password_placeholder: 'ยืนยันรหัสผ่านของคุณ',
    submit: 'รีเซ็ตรหัสผ่าน',
    success_message: 'รีเซ็ตรหัสผ่านเรียบร้อยแล้ว',
    invalid_token: 'โทเค็นไม่ถูกต้องหรือหมดอายุ',
    passwords_not_match: 'รหัสผ่านไม่ตรงกัน',
  },

  // EP-160 (section 2.7, D5): the owner's one-time banner when the terms
  // change. A banner, never a gate.
  terms_banner: {
    message: 'FlowRent ปรับปรุงข้อตกลงการใช้บริการ',
    read: 'อ่านข้อตกลง',
    accept: 'ยอมรับ',
    dismiss: 'ปิด',
    accept_failed: 'บันทึกการยอมรับไม่สำเร็จ กรุณาลองอีกครั้ง',
  },

  errors: {
    invalid_credentials: 'อีเมลหรือรหัสผ่านไม่ถูกต้อง',
    account_locked: 'บัญชีของคุณถูกล็อค',
    session_expired: 'เซสชันหมดอายุ กรุณาเข้าสู่ระบบใหม่',
    owner_required: 'มีเพียงเจ้าของบัญชีเท่านั้นที่กู้คืนบัญชีนี้ได้',
    not_pending_deletion: 'บัญชีนี้ไม่ได้อยู่ระหว่างรอลบ',
  },
}
